<kendo-dialog *ngIf="show()"
              class="isg-dialog-editor isg-dialog-top"
              [height]="250"
              [width]="400"
              [title]="'Create New Scenario'"
              (close)="onCancel()">

  <div kendoDialogBody class="pb-scenario-layout">

    <kendo-label text="Please select the module"></kendo-label>

    <!-- Picklist -->
    <kendo-combobox [data]="dealGroupList"
                    [popupSettings]="{ popupClass: 'my-dropdown-popup' }"
                    [textField]="'name'"
                    [valueField]="'id'"
                    [(ngModel)]="dealGroupId"
                    class="pb-def-control-width"
                    (selectionChange)="onDealGroupChange($event)"
                    >
    </kendo-combobox>

    <kendo-label text="Scenario Name"></kendo-label>

    <kendo-textbox [(ngModel)]="dealName"
                   class="pb-def-control-width">
    </kendo-textbox>
   <div class="k-form-error"
     *ngIf="ctscenarioNameMaxlength && (dealName || '').length > ctscenarioNameMaxlength">
      Maximum length is {{ ctscenarioNameMaxlength }} characters.
    </div>
    <div class="k-form-error"
     *ngIf="hasSlashInName()">
      Slash characters ( / and \ ) are not allowed.
    </div>
  </div>

  <kendo-dialog-actions>

    <button kendoButton
            themeColor="primary"
            [disabled]="!dealGroupId || !dealName.trim() || hasSlashInName() || (!!ctscenarioNameMaxlength && (dealName || '').length > ctscenarioNameMaxlength)"
            (click)="onSave()">
      Create
    </button>
    <button kendoButton (click)="onCancel()">Cancel</button>

  </kendo-dialog-actions>

</kendo-dialog>
